var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { triggerSortTableManually } from 'services/table.service';
import { STUDENT_ENGAGEMENT_TABLE_SELECTOR } from 'reports/cw/constants/report.constant';
import { cwSelectors } from 'reports/cw/redux/ducks/cw';
import ResponsiveTable from 'components/common/responsive-table/ResponsiveTable';
import { FeatureFlagNames, SORT_DIRECTION } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { renderAvgTimeSpent } from 'reports/cw/helpers/student-assignment.helper';
import { renderAvgTimePerQuestion, renderStudentAvgScore, renderAvgTimePerQuestionComparedToClass, renderPastDue, renderName, renderComparedPerformance, renderStudentTotalGradePoints, renderTotalLogins, renderLastLogin, renderTotalSelfStudyTime } from '../student-engagement-table-helper/StudentEngagementTableHelper';
import { isFeatureEnabled } from '../../../../../../services/feature-flag.service';
var StudentEngagementTable = function (_a) {
    var avgScoreOfClass = _a.avgScoreOfClass, tableData = _a.tableData, featureFlags = _a.featureFlags, isEAQAssignmentType = _a.isEAQAssignmentType, isGradePointsHidden = _a.isGradePointsHidden, isOsmosisAssignmentType = _a.isOsmosisAssignmentType, studentEngagementSort = _a.studentEngagementSort;
    var interactionWithCard = useCallback(function () {
        if (studentEngagementSort) {
            triggerSortTableManually(studentEngagementSort.sortDirection, ".".concat(studentEngagementSort.columnHeaderSelector));
        }
    }, [studentEngagementSort]);
    useEffect(function () {
        interactionWithCard();
    }, [studentEngagementSort, interactionWithCard]);
    var studentAverageScoreColumn = STUDENT_ENGAGEMENT_TABLE_SELECTOR.studentAverageScoreColumn, timeSpentComparedToClassAvgColumn = STUDENT_ENGAGEMENT_TABLE_SELECTOR.timeSpentComparedToClassAvgColumn, numberOfStudentsWithPastDueColumn = STUDENT_ENGAGEMENT_TABLE_SELECTOR.numberOfStudentsWithPastDueColumn, selfStudyQuestionsAttemptedColumn = STUDENT_ENGAGEMENT_TABLE_SELECTOR.selfStudyQuestionsAttemptedColumn;
    var eaqAssignmentColumns = isEAQAssignmentType
        ? [
            {
                field: 'numberOfAssignedQuestionsAttempted',
                header: '# Assigned Questions Attempted'
            },
            {
                field: 'numberOfSelfStudyQuestionsAttempted',
                header: '# Self-Study Questions Attempted',
                headerCssModifier: selfStudyQuestionsAttemptedColumn
            }
        ]
        : [];
    var columns = __spreadArray(__spreadArray(__spreadArray([
        {
            field: 'studentName',
            header: 'Student',
            customRender: renderName,
            minWidth: 250
        },
        {
            field: 'percentAvgScore',
            header: 'Student Avg Score',
            headerCssModifier: studentAverageScoreColumn,
            customRender: renderStudentAvgScore,
            sortNARecordInBottom: true
        },
        {
            field: 'performanceComparedToClassAvg',
            header: 'Performance Compared to Class Avg',
            customRender: function (row) { return renderComparedPerformance(row, avgScoreOfClass); },
            cssModifier: 'u-position-relative u-els-padding-none',
            minWidth: 200
        },
        {
            field: 'totalGradePoints',
            header: 'Student Total Grade Points',
            customRender: function (row) { return renderStudentTotalGradePoints(row, featureFlags); },
            minWidth: 150,
            align: 'right'
        }
    ], eaqAssignmentColumns, true), (isEAQAssignmentType
        ? [
            {
                field: 'avgTimeSpent',
                header: 'Avg Time Spent',
                customRender: renderAvgTimeSpent,
                sortNARecordInBottom: true,
                minWidth: 120
            }
        ]
        : []), true), [
        {
            field: 'avgTimePerQuestionSeconds',
            header: isEAQAssignmentType ? 'Avg Time per Question' : 'Student Avg Time Spent',
            customRender: renderAvgTimePerQuestion
        },
        {
            field: 'avgTimePerQuestionComparedToClassAvgSeconds',
            header: isEAQAssignmentType ? 'Avg Time per Question Compared to Class Avg' : 'Avg Time Spent Compared to Class Avg',
            headerCssModifier: timeSpentComparedToClassAvgColumn,
            customRender: renderAvgTimePerQuestionComparedToClass
        },
        {
            field: 'pastDue',
            header: '# Past Due',
            headerCssModifier: numberOfStudentsWithPastDueColumn,
            customRender: renderPastDue,
            minWidth: 100
        },
        {
            field: 'totalLogins',
            header: 'Total Logins',
            customRender: renderTotalLogins
        },
        {
            field: 'lastLogin',
            header: 'Last Login Date/Time',
            customRender: renderLastLogin
        },
        {
            field: 'totalTimeSpentOnSelfStudySeconds',
            header: 'Total Self Study Time',
            customRender: renderTotalSelfStudyTime
        }
    ], false);
    if (isGradePointsHidden) {
        columns = columns.filter(function (c) { return c.field !== 'totalGradePoints'; });
    }
    if (isOsmosisAssignmentType) {
        columns = columns.filter(function (c) {
            var field = c.field;
            return field !== 'avgTimePerQuestionSeconds' && field !== 'avgTimePerQuestionComparedToClassAvgSeconds';
        });
    }
    var isPerformanceComparedToClassAvgHidden = isFeatureEnabled(featureFlags, FeatureFlagNames.CW_PERFORMANCE_COMPARED_TO_CLASS_AVERAGE_HIDDEN);
    if (isPerformanceComparedToClassAvgHidden) {
        columns = columns.filter(function (c) { return c.field !== 'performanceComparedToClassAvg'; });
    }
    var tableProps = {
        cssModifier: 'u-els-margin-top-2x c-cw-student-engagement-table',
        defaultSortField: 'percentAvgScore',
        defaultSortDirection: SORT_DIRECTION.ASC
    };
    return <ResponsiveTable columns={columns} records={tableData} tableProps={tableProps}/>;
};
var mapStateToProps = function (state) { return ({
    studentEngagementSort: cwSelectors.getStudentEngagementSort(state),
    featureFlags: appSelectors.getFeatureFlags(state)
}); };
export { StudentEngagementTable as StudentEngagementTableBase };
export default connect(mapStateToProps)(StudentEngagementTable);
